import React from 'react'
import Background from 'components/Background'

const GenerateCodeSetViewBackground = () => (
  <Background height="45vh" />
)
export default GenerateCodeSetViewBackground
